import React from 'react';
import ReactDOM from 'react-dom/client';
import BuildingRepairApp from './ATD-audit';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BuildingRepairApp />
  </React.StrictMode>

);
